import { IPlatform } from "./../../interfaces/i-platform";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { GetBaseUrl } from "app/helper/getBaseUrl";
import { Observable } from "rxjs";

const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable()
export class ApiPlatformService {
    private baseUrl = GetBaseUrl.baseUrl();

    constructor(private http: HttpClient) {}

    public getOneById(id_platform: number): Observable<IPlatform> {
        return this.http.get<IPlatform>(
            this.baseUrl + "/platform/" + id_platform
        );
    }
}
